import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { WishlistProvider } from './contexts/WishlistContext';
import ErrorBoundary from './components/ErrorBoundary';
import SplashScreen from './components/SplashScreen';
import LandingPage from './components/LandingPage';
import IntroScreen from './components/IntroScreen';
import GenderSelection from './components/GenderSelection';
import CategorySelection from './components/CategorySelection';
import ProductCatalog from './components/ProductCatalog';
import DesignStudio from './components/DesignStudio';
// LunoraScanner archived to /components/_archive — 3DLOOK Mobile Tailor widget is now the
// only customer body-measurement path (launched from ScanStep in StylistFlow and
// StartBodyScanButton on MyFitProfile).
import MyFitProfile from './components/MyFitProfile';
import Checkout from './components/Checkout';
import OrderTracking from './components/OrderTracking';
import CustomerAuth from './components/CustomerAuth';
import ForgotPassword from './components/ForgotPassword';
import ResetPassword from './components/ResetPassword';
import MyOrders from './components/MyOrders';
import Wishlist from './components/Wishlist';
import PaymentResult from './components/PaymentResult';
import Referrals from './components/Referrals';
import StylistFlow from './components/StylistFlow';
import TailorLogin from './components/TailorLogin';
import TailorDashboard from './components/TailorDashboard';
import TailorNotifications from './components/TailorNotifications';
import TailorSettings from './components/TailorSettings';
import DeliveryNegotiation from './components/DeliveryNegotiation';
import AdminPanel from './components/AdminPanel';
import InfoPage from './components/InfoPage';
import './App.css';

function App() {
  return (
    <ErrorBoundary>
      <AuthProvider>
        <WishlistProvider>
        <div className="App">
          <BrowserRouter>
            <Routes>
              {/* Customer Flow */}
              <Route path="/" element={<SplashScreen />} />
              <Route path="/landing" element={<LandingPage />} />
              <Route path="/intro" element={<IntroScreen />} />
              <Route path="/auth" element={<CustomerAuth />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/reset-password" element={<ResetPassword />} />
              <Route path="/my-orders" element={<MyOrders />} />
              <Route path="/wishlist" element={<Wishlist />} />
              <Route path="/payment-result" element={<PaymentResult />} />
              <Route path="/referrals" element={<Referrals />} />
              <Route path="/measurements" element={<StylistFlow />} />
              <Route path="/gender-selection" element={<GenderSelection />} />
              <Route path="/category-selection" element={<CategorySelection />} />
              <Route path="/product-catalog" element={<ProductCatalog />} />
              <Route path="/design-studio" element={<DesignStudio />} />
              {/* /scanner route removed — 3DLOOK-only body-scan mode. */}
              <Route path="/my-fit-profile" element={<MyFitProfile />} />
              <Route path="/checkout" element={<Checkout />} />
              <Route path="/order-tracking" element={<OrderTracking />} />
              
              {/* Tailor Portal */}
              <Route path="/tailor-login" element={<TailorLogin />} />
              <Route path="/tailor-dashboard" element={<TailorDashboard />} />
              <Route path="/tailor-notifications" element={<TailorNotifications />} />
              <Route path="/tailor-settings" element={<TailorSettings />} />
              <Route path="/delivery-negotiation" element={<DeliveryNegotiation />} />
              
              {/* Admin */}
              <Route path="/admin" element={<AdminPanel />} />
              
              {/* Info Pages */}
              <Route path="/info/:page" element={<InfoPage />} />
            </Routes>
          </BrowserRouter>
        </div>
        </WishlistProvider>
      </AuthProvider>
    </ErrorBoundary>
  );
}

export default App;
